import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "size--a" }

import InnInput from "@/components/ds/input/Input.vue";
import { PropType } from "vue";
import { Line } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentLineText',
  props: {
    line: {
        type: Object as PropType<Line>,
        required: true,
    },
    locked: {
        type: Boolean,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.locked)
      ? (_openBlock(), _createBlock(InnInput, {
          key: 0,
          modelValue: __props.line.text,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.line.text) = $event)),
          placeholder: "Titel",
          compact: ""
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (__props.locked)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString(__props.line.text), 1)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})